import { render } from "./AsiaView.vue?vue&type=template&id=1b441798"
import script from "./AsiaView.vue?vue&type=script&lang=js"
export * from "./AsiaView.vue?vue&type=script&lang=js"

import "./AsiaView.vue?vue&type=style&index=0&id=1b441798&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__